import React from 'react';
import { Ambient } from '../Ambient';
import { PartnershipLockup, VexuMark } from '../Brand';
import { Hairline, Reveal } from '../Reveal';
export function ClosingSlide() {
  return <section className="relative h-full w-full" data-id="element-587" data-mp="2ky9u3ozrevyw">
      <Ambient variant="cover" data-id="element-588" data-mp="2kwyqbp6bdo7s" />

      <div className="relative flex h-full flex-col items-center justify-center px-[110px] text-center" data-id="element-589" data-mp="2kw6xun80k6lq">
        <Reveal delay={0} data-id="element-590" data-mp="2bxv8spmspgve">
          <VexuMark size={62} data-id="element-591" data-mp="2by4xm9w3thzi" />
        </Reveal>

        <Reveal delay={0.1} y={18} data-id="element-592" data-mp="2bvs91dvuc9dh">
          <h2 className="mt-[46px] max-w-[1120px] text-[58px] font-semibold leading-[1.12] tracking-[-0.032em] text-slate-900" data-id="element-593" data-mp="26y8v6f321ym2">
            Powering the Next Generation of
            <br data-id="element-594" data-mp="221id5m7owsy0" />
            AI-Enabled Telecom Services
          </h2>
        </Reveal>

        <Reveal delay={0.2} data-id="element-595" data-mp="1x2p2s2np9i22">
          <div className="mt-[44px] flex items-center gap-[22px] text-[19px] font-light tracking-[0.02em] text-slate-500" data-id="element-596" data-mp="82blua2dto9">
            <span data-id="element-597" data-mp="3rfoli4ndmsdk">Consumer.</span>
            <span className="h-[3px] w-[3px] rounded-full bg-vexu" data-id="element-598" data-mp="3rfes0734i334" />
            <span data-id="element-599" data-mp="299huolhamapv">Business.</span>
            <span className="h-[3px] w-[3px] rounded-full bg-vexu" data-id="element-600" data-mp="29cm7u8cqkgso" />
            <span data-id="element-601" data-mp="2eae053ham4xe">Commerce.</span>
          </div>
        </Reveal>

        <Reveal delay={0.28} data-id="element-602" data-mp="1zclo4layfyny">
          <p className="mt-[18px] text-[19px] font-medium tracking-[-0.01em] text-slate-900" data-id="element-603" data-mp="1zdn9biloq1je">
            One Technology Platform.
          </p>
        </Reveal>

        <Reveal delay={0.38} className="mt-[72px] w-[560px]" data-id="element-604" data-mp="2s1arkqzhgg2v">
          <Hairline data-id="element-605" data-mp="2s1ss3zt6hggl" />
          <div className="flex justify-center pt-[32px]" data-id="element-606" data-mp="2x044oiauy52i">
            <PartnershipLockup vexuSize={34} vexuWordmarkSize={21} zainHeight={29} data-id="element-607" data-mp="2wzklky9h1amw" />
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.48} data-id="element-608" data-mp="2n9974hs5vj1r">
        <div className="absolute inset-x-0 bottom-[44px] flex items-center justify-center gap-[20px]" data-id="element-609" data-mp="2n8hmu340l7qs">
          <span className="text-[13px] font-medium tracking-[-0.01em] text-slate-900" data-id="element-610" data-mp="3ayk73x1ot9eu">
            Fadi Rayyan
          </span>
          <span className="text-[12px] font-light text-slate-500" data-id="element-611" data-mp="3pmlsk8t5ymdp">
            Founder &amp; CEO
          </span>
          <span className="h-[11px] w-px bg-slate-300" data-id="element-612" data-mp="3kmzddttryw29" />
          <a href="tel:+971585377090" className="text-[12px] font-light tabular-nums text-slate-500 transition-colors duration-200 ease-out hover:text-vexu-700" data-id="element-613" data-mp="3kleho0vq572t">
            +971 58 537 7090
          </a>
          <span className="h-[11px] w-px bg-slate-300" data-id="element-614" data-mp="36o9fwd31mudd" />
          <a href="mailto:fadi@vexu.ai" className="text-[12px] font-light text-slate-500 transition-colors duration-200 ease-out hover:text-vexu-700" data-id="element-615" data-mp="36psw63op95f5">
            fadi@vexu.ai
          </a>
        </div>
      </Reveal>
    </section>;
}